'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutContainer } from '@petsmart-ui/sparky';
import CampaignHeroFullWidth from './CampaignHeroFullWidth';
import CampaignHeroMd from './CampaignHeroMd';
import CampaignHeroSplit from './CampaignHeroSplit';
import type { CampaignHeroProps } from './types';
import './CampaignHero.scss';
const CampaignHeroComponent = {
  'Full Width': CampaignHeroFullWidth,
  Split: CampaignHeroSplit,
  Md: CampaignHeroMd
};
export default function CampaignHero(props) {
  const $ = _c(3);
  const Component = CampaignHeroComponent[props.variant];
  let t0;
  if ($[0] !== Component || $[1] !== props) {
    t0 = <LayoutContainer className="campaign-hero-container"><Component {...props} /></LayoutContainer>;
    $[0] = Component;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}